import { initSubRoutes } from '../../utils/router';

const RoutesPubliqueAccessibilite = initSubRoutes({
    route: '/accessibilite',
    subroutes: {},
    nom: 'Accessibilité',
});

export default RoutesPubliqueAccessibilite;
